import domain from './domain';

export const resetTaskCategories = domain.createEvent('resetTaskCategories');
